import React, { Component } from "react";
import { DatePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import DialogDatePickerViewProps from "./DialogDatePickerViewProps";
import TranslationView from "../../../../../../components/Translation/TranslationView";
import { subDays } from 'date-fns';
import { MuiThemeProvider } from "@material-ui/core";
import DialogDatePickerViewStyle from "./DialogDatePickerViewStyle";

export default class DialogDatePickerView extends Component<DialogDatePickerViewProps> {

    static MIN_DEFAULT_DATE = subDays(new Date(), 30);

    private _style = new DialogDatePickerViewStyle();

    private _onChange = (date : MaterialUiPickersDate, _? : string | null) => {
        if (!date) {
            return;
        }

        this.props.onChange(date);
    }

    render() {
        const { label, format, value, minDate, maxDate, style, error } = this.props;
        return (
            <MuiThemeProvider theme={this._style.pickerTheme}>
                <DatePicker
                    autoOk
                    label={TranslationView.translate(label)}
                    format={format || 'dd/MM/yyyy'}
                    value={value || null}
                    onChange={this._onChange}
                    minDate={minDate || DialogDatePickerView.MIN_DEFAULT_DATE}
                    maxDate={maxDate}
                    style={style}
                    error={!!this.props.error}
                    helperText={error ? TranslationView.translate(error) : " "} />
            </MuiThemeProvider>
        );
    }
}